module.exports = __webpack_public_path__ + "img/dummy13.e67197f.jpg";